import { Component, Input } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { TPVServices } from '../../../tpv/services';
import { OrdersCoServices } from '../../../orders/services';
import { TranslateService } from '@ngx-translate/core';
import { VariationsDishSelectorPage } from '../../../variations/variations-dish-selector/variations-dish-selector';
import { TakeawayServices } from '../../../takeaway/services';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';

/**
 * Generated class for the  page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-pos-dish',
  templateUrl: 'pos-dish.html',
})
export class PosDishPage {

  @Input() origin: string;
  @Input() platform: string;
  @Input() element_type: string;
  @Input() element: string;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    private tpvServices: TPVServices,
    public ordersCoServices: OrdersCoServices,
    public translate: TranslateService,
    public toastCtrl: ToastController,
    public takeawayServices: TakeawayServices) {
  }

  insertToTicketDish(dish, _price, _delete, _count, _type, _uid, _section) {
    if (this.origin === 'comandero') {
      //Comprovamos que el plato tenga el idioma seleccionado
      if (this.tpvServices.nameLangSelect(this.globals.restaurant.lang, dish)) {
        this.ordersCoServices.insertTable(this.tpvServices.nameLangSelect(this.globals.restaurant.lang, dish), _price, _delete, _count, _type, _uid, _section, dish);
      } else {
        this.ordersCoServices.insertTable('no name - ' + _price, _price, _delete, _count, _type, _uid, _section, dish);
      }


      let toast = this.toastCtrl.create({
        message: this.tpvServices.nameLangSelect(this.globals.restaurant.lang, dish) + " " + this.translate.instant('instant-anadido-correctemente'),
        duration: 3000,
        position: 'top'
      });
      this.ordersCoServices.count_elements++;//insert ++
      toast.present();
    } else {
      //Comprovamos que el plato tenga el idioma seleccionado
      if (this.tpvServices.nameLangSelect(this.globals.restaurant.lang, dish)) {
        this.takeawayServices.insertTable(this.tpvServices.nameLangSelect(this.globals.restaurant.lang, dish), _price, _delete, _count, _type, _uid, _section, dish);
      } else {
        this.takeawayServices.insertTable('no name - ' + _price, _price, _delete, _count, _type, _uid, _section, dish);
      }


      let toast = this.toastCtrl.create({
        message: this.tpvServices.nameLangSelect(this.globals.restaurant.lang, dish) + " " + this.translate.instant('instant-anadido-correctemente'),
        duration: 3000,
        position: 'top'
      });
      toast.present();
    }
  }

  lpDish(dish, _price, _priceHalf, _priceTapa, _type, _uid, section) {
    if (this.origin === 'comandero') {
      //Comprovamos que el plato tenga el idioma seleccionado
      if (this.tpvServices.nameLangSelect(this.globals.restaurant.lang, dish)) {
        this.navCtrl.push(VariationsDishSelectorPage, {
          name: this.tpvServices.nameLangSelect(this.globals.restaurant.lang, dish),
          price: _price,
          price12: _priceHalf,
          priceTapa: _priceTapa,
          type: _type,
          uid: _uid,
          section: section,
          sender: 'comandero',
          tags: dish.tags,
        });
      } else {
        this.navCtrl.push(VariationsDishSelectorPage, {
          name: 'no name - ' + _price,
          price: _price,
          price12: _priceHalf,
          priceTapa: _priceTapa,
          type: _type,
          uid: _uid,
          section: section,
          sender: 'comandero',
          tags: dish.tags,
        });
      }
    } else {
      //Comprovamos que el plato tenga el idioma seleccionado
      if (this.tpvServices.nameLangSelect(this.globals.restaurant.lang, dish)) {
        this.navCtrl.push(VariationsDishSelectorPage, {
          name: this.tpvServices.nameLangSelect(this.globals.restaurant.lang, dish),
          price: _price,
          price12: _priceHalf,
          priceTapa: _priceTapa,
          type: _type,
          uid: _uid,
          section: section,
          sender: 'takeaway',
          tags: dish.tags,
        });
      } else {
        this.navCtrl.push(VariationsDishSelectorPage, {
          name: 'no name - ' + _price,
          price: _price,
          price12: _priceHalf,
          priceTapa: _priceTapa,
          type: _type,
          uid: _uid,
          section: section,
          sender: 'takeaway',
          tags: dish.tags,
        });
      }
    }

  }

  //TPV
  lpDishTPV(dish, _price, _priceHalf, _priceTapa, _type, _uid) {
    if (this.globals.checkLimitsByLicense('tpv', 'variations')) {
      //Comprovamos que el plato tenga el idioma seleccionado
      if (this.tpvServices.nameLangSelect(this.globals.restaurant.lang, dish)) {
        this.navCtrl.push(VariationsDishSelectorPage, {
          name: this.tpvServices.nameLangSelect(this.globals.restaurant.lang, dish),
          price: _price,
          price12: _priceHalf,
          priceTapa: _priceTapa,
          type: _type,
          uid: _uid,
          sender: 'tpv',
          tags: dish.tags,
        });
      } else {
        this.navCtrl.push(VariationsDishSelectorPage, {
          name: 'no name - ' + _price,
          price: _price,
          price12: _priceHalf,
          priceTapa: _priceTapa,
          type: _type,
          uid: _uid,
          sender: 'tpv',
          tags: dish.tags,
        });
      }
      this.tpvServices.autoScrollEnterElements();
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  insertToTicketDishTPV(dish, _price, _delete, _count, _type, _uid) {

    this.tpvServices.deleteKeyboard();
    //Comprovamos que el plato tenga el idioma seleccionado
    if (this.tpvServices.nameLangSelect(this.globals.restaurant.lang, dish)) {
      this.tpvServices.insertTable(this.tpvServices.nameLangSelect(this.globals.restaurant.lang, dish), _price, _delete, _count, _type, _uid, dish);
    } else {//Si el plato no tiene nombre en el idioma seleccionado, pasamos un string
      this.tpvServices.insertTable('no name - ' + _price, _price, _delete, _count, _type, _uid, dish);
    }

    if (this.globals.tour != '') {
      this.globals.tour_step_user = 5;
    }
    this.tpvServices.autoScrollEnterElements();
  }

}



// WEBPACK FOOTER //
// ./src/pages/components/pos/pos-dish/pos-dish.ts